
import { Component, Vue } from 'vue-property-decorator';
import ManageDialog from '@/components-business/manage-dialog.vue';
import { namespace } from 'vuex-class';
import { Alert } from 'ant-design-vue';
import cookies from 'js-cookie';

const userModule = namespace('user');

interface IclassNumInfo {
  jumpPower: number;
  classNum: number;
}

@Component({
  components: {
    AAlert: Alert,
    ManageDialog,
  },
})
export default class CommonAlert extends Vue {
  @userModule.Getter('userInfo') userInfo: any;

  @userModule.Getter('isManage') isManage!: boolean;

  @userModule.Getter('getAccountStatus') getAccountStatus: any;

  @userModule.Getter('isSuperManage') isSuperManage!: boolean;

  @userModule.Getter('isDoubleTeacher') isDoubleTeacher!: boolean;

  private visible: boolean = true;

  // 管理员弹框状态
  private manageDialogVisible: boolean = false;

  // 管理员弹框title
  private titleTips: string = '';

  // 判断是否过期
  get accountExpired(): boolean {
    return this.getAccountStatus === 2 || this.getAccountStatus === 4;
  }

  get classNumInfo(): IclassNumInfo {
    const { classNumInfo } = this.userInfo;
    return classNumInfo;
  }

  get isClosed(): boolean {
    return !!(this.userInfo && cookies.get(`noclazz_${this.userInfo.userId}`));
  }

  // 关闭
  private handleClose(type: string) {
    this.visible = false;
    if (type === 'createClass') {
      cookies.set(`noclazz_${this.userInfo.userId}`, 1);
    }
  }

  // 点击续费
  private handleCharge() {
    if (this.isManage || this.isSuperManage) {
      window.open(
        `//ghostrider.aixuexi.com/userinfo.html#/user/renewalfee?orgType=1&teacherType=${this.isDoubleTeacher ? 2 : 1}`,
      );
    } else {
      this.titleTips = '您暂无续费权限，请联系以下负责人续费';
      this.manageDialogVisible = true;
    }
  }

  // 点击创建班级
  private handleCreate() {
    if (this.classNumInfo.jumpPower) {
      window.open(
        '//ghostrider.aixuexi.com/education.html#/orgclass/create?type=0&createType=0',
      );
    } else {
      this.titleTips = '您暂无建班权限，请联系以下负责人进行建班';
      this.manageDialogVisible = true;
    }
  }
}
